import { render } from "./RegionAtyrauObl.vue?vue&type=template&id=a38c6462&ts=true"
import script from "./RegionAtyrauObl.vue?vue&type=script&lang=ts"
export * from "./RegionAtyrauObl.vue?vue&type=script&lang=ts"

import "./RegionAtyrauObl.vue?vue&type=style&index=0&id=a38c6462&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__